// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 6755 ? "premiumcarousel.637162dd" : chunkId) + "--" + {"3332":"01a1393","3543":"09c0f84","5273":"e4b4d2d","6755":"8c92923"}[chunkId] + ".css";
};